module.exports = [
  {
    env: 'test',
    domain: ['astrazeneca.nges.qq.com'],
    mobileDomain: 'astrazeneca-h5.nges.qq.com',
    aegisId: 'yrpj3fl9ZbjVJgrGR4',
    reportDomain: 'baike.sparta.html5.qq.com',
  },
  {
    env: 'test',
    domain: 'ncep-test.astrazeneca.cn',
    aegisId: 'yrpj3fl9ZbjVJgrGR4',
    reportDomain: 'externaltest.medical.qq.com',
    wemeetSdkId: '18770108633',
    loginCodePath: '',
  },
];
